module.exports = __webpack_public_path__ + "static/img/zidongjieting.cea3964.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/zidongjieting.png
// module id = 19kL
// module chunks = 24